<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="min-h-screen flex">
    <!-- 左侧表单区域 -->
    <div class="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12">
      <div class="w-full max-w-md space-y-8">
        <!-- Logo 和标题 -->
        <div class="text-center">
          <div class="flex justify-center mb-6">
            <img
              src="@/assets/logo.png"
              alt="Logo"
              class="w-14 h-14 rounded-xl object-contain"
            />
          </div>
          <h1 class="text-2xl sm:text-3xl font-bold text-slate-900">小到大企服平台</h1>
          <p class="mt-2 text-slate-600">{{ viewSubtitle }}</p>
        </div>

        <!-- 登录表单 -->
        <form v-if="currentView === 'login'" class="mt-8 space-y-6" @submit.prevent="handleLogin">
          <!-- 手机号 -->
          <div>
            <label for="phone" class="block text-sm font-medium text-slate-700 mb-2">手机号</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"/>
                </svg>
              </div>
              <input
                id="phone"
                v-model="form.phone"
                name="phone"
                type="tel"
                required
                class="form-search-input"
                placeholder="请输入手机号"
              >
            </div>
          </div>

          <!-- 密码 -->
          <div>
            <label for="password" class="block text-sm font-medium text-slate-700 mb-2">密码</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                </svg>
              </div>
              <input
                id="password"
                v-model="form.password"
                name="password"
                :type="showPassword ? 'text' : 'password'"
                required
                class="form-search-input form-input-with-suffix"
                placeholder="请输入密码"
              >
              <button
                type="button"
                @click="showPassword = !showPassword"
                :aria-label="showPassword ? '隐藏密码' : '显示密码'"
                :aria-pressed="showPassword"
                class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-slate-400 hover:text-slate-600 transition-colors"
              >
                <svg v-if="showPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                </svg>
                <svg v-else class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- 记住我和忘记密码 -->
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <input id="remember" v-model="form.remember" name="remember" type="checkbox" class="form-check">
              <label for="remember" class="ml-2 block text-sm text-slate-700 cursor-pointer">记住我</label>
            </div>
            <button type="button" class="text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors cursor-pointer" @click="switchToReset">忘记密码?</button>
          </div>

          <!-- 登录按钮 -->
          <div>
            <button
              type="submit"
              :disabled="loading"
              class="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-all duration-200 shadow-lg shadow-primary-500/25 hover:shadow-xl hover:shadow-primary-500/30 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span v-if="loading" class="absolute inset-y-0 left-0 pl-3 flex items-center">
                <svg class="animate-spin h-5 w-5 text-primary-300" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
              <span :class="{ 'pl-7': loading }">{{ loading ? '登录中...' : '登录' }}</span>
            </button>
          </div>
        </form>

        <!-- 租户选择 -->
        <div v-else-if="currentView === 'tenant'" class="mt-8 space-y-6">
          <div class="text-center">
            <p class="text-sm text-slate-500">该账号关联了多个租户，请选择要登录的租户</p>
          </div>

          <div class="space-y-3">
            <button
              v-for="tenant in tenantList"
              :key="tenant.tenantId"
              type="button"
              :disabled="selectingTenant"
              class="w-full flex items-center gap-4 p-4 border border-slate-200 rounded-lg hover:border-primary-400 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed group"
              @click="handleSelectTenant(tenant)"
            >
              <div class="flex-shrink-0 w-10 h-10 bg-primary-100 text-primary-600 rounded-lg flex items-center justify-center font-semibold group-hover:bg-primary-200 transition-colors">
                {{ tenant.tenantName?.charAt(0) || 'T' }}
              </div>
              <div class="flex-1 text-left">
                <div class="text-sm font-medium text-slate-900">{{ tenant.tenantName }}</div>
                <div v-if="tenant.nickname" class="text-xs text-slate-500 mt-0.5">{{ tenant.nickname }}</div>
              </div>
              <svg class="w-5 h-5 text-slate-300 group-hover:text-primary-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
          </div>

          <div v-if="selectingTenant" class="flex items-center justify-center gap-2 text-sm text-slate-500">
            <svg class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            登录中...
          </div>

          <!-- 返回登录 -->
          <div class="text-center">
            <button type="button" class="text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors cursor-pointer" @click="switchToLogin">
              <span class="inline-flex items-center gap-1">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
                </svg>
                返回登录
              </span>
            </button>
          </div>
        </div>

        <!-- 重置密码表单 -->
        <form v-else class="mt-8 space-y-5" @submit.prevent="handleResetPassword">
          <!-- 手机号 -->
          <div>
            <label for="resetPhone" class="block text-sm font-medium text-slate-700 mb-2">手机号</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
              </div>
              <input
                id="resetPhone"
                v-model="resetForm.phone"
                type="tel"
                maxlength="11"
                class="form-search-input"
                placeholder="请输入手机号"
              >
            </div>
          </div>

          <!-- 验证码 -->
          <div>
            <label for="smsCode" class="block text-sm font-medium text-slate-700 mb-2">验证码</label>
            <div class="flex gap-3">
              <div class="relative flex-1">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg class="h-5 w-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                  </svg>
                </div>
                <input
                  id="smsCode"
                  v-model="resetForm.smsCode"
                  type="text"
                  maxlength="6"
                  class="form-search-input"
                  placeholder="请输入验证码"
                >
              </div>
              <button
                type="button"
                :disabled="countdown > 0 || sendingCode"
                class="flex-shrink-0 px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200 cursor-pointer disabled:cursor-not-allowed"
                :class="countdown > 0 || sendingCode
                  ? 'bg-slate-100 text-slate-400 border border-slate-200'
                  : 'bg-primary-50 text-primary-600 border border-primary-200 hover:bg-primary-100'"
                @click="handleSendCode"
              >
                <span v-if="sendingCode">发送中...</span>
                <span v-else-if="countdown > 0">{{ countdown }}s后重试</span>
                <span v-else>获取验证码</span>
              </button>
            </div>
          </div>

          <!-- 新密码 -->
          <div>
            <label for="resetPassword" class="block text-sm font-medium text-slate-700 mb-2">新密码</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                </svg>
              </div>
              <input
                id="resetPassword"
                v-model="resetForm.newPassword"
                :type="showResetPassword ? 'text' : 'password'"
                class="form-search-input form-input-with-suffix"
                placeholder="6-20位，必须包含大小写字母和数字"
                @input="resetError = ''"
              >
              <button
                type="button"
                @click="showResetPassword = !showResetPassword"
                :aria-label="showResetPassword ? '隐藏密码' : '显示密码'"
                :aria-pressed="showResetPassword"
                class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-slate-400 hover:text-slate-600 transition-colors"
              >
                <svg v-if="showResetPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                </svg>
                <svg v-else class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- 确认密码 -->
          <div>
            <label for="resetConfirmPassword" class="block text-sm font-medium text-slate-700 mb-2">确认密码</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                </svg>
              </div>
              <input
                id="resetConfirmPassword"
                v-model="resetForm.confirmPassword"
                :type="showResetConfirmPassword ? 'text' : 'password'"
                class="form-search-input form-input-with-suffix"
                :class="{ 'is-error': resetConfirmError }"
                placeholder="请再次输入新密码"
                @input="resetError = ''"
              >
              <button
                type="button"
                @click="showResetConfirmPassword = !showResetConfirmPassword"
                :aria-label="showResetConfirmPassword ? '隐藏密码' : '显示密码'"
                :aria-pressed="showResetConfirmPassword"
                class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-slate-400 hover:text-slate-600 transition-colors"
              >
                <svg v-if="showResetConfirmPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                </svg>
                <svg v-else class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- 错误提示 -->
          <p v-if="resetError" class="text-sm text-red-600">{{ resetError }}</p>
          <p v-else-if="resetConfirmError" class="text-sm text-red-600">两次输入的密码不一致</p>

          <!-- 重置密码按钮 -->
          <div>
            <button
              type="submit"
              :disabled="resetting"
              class="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-all duration-200 shadow-lg shadow-primary-500/25 hover:shadow-xl hover:shadow-primary-500/30 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span v-if="resetting" class="absolute inset-y-0 left-0 pl-3 flex items-center">
                <svg class="animate-spin h-5 w-5 text-primary-300" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
              <span :class="{ 'pl-7': resetting }">{{ resetting ? '提交中...' : '重置密码' }}</span>
            </button>
          </div>

          <!-- 返回登录 -->
          <div class="text-center">
            <button type="button" class="text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors cursor-pointer" @click="switchToLogin">
              <span class="inline-flex items-center gap-1">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
                </svg>
                返回登录
              </span>
            </button>
          </div>
        </form>

        <!-- 版权信息 -->
        <div class="text-center">
          <p class="text-xs text-slate-400">© 2026 小到大企服平台 版权所有</p>
        </div>
      </div>
    </div>

    <!-- 右侧品牌展示区域 -->
    <div class="hidden lg:flex lg:flex-1 gradient-bg relative overflow-hidden">
      <!-- 装饰背景 -->
      <div class="absolute inset-0">
        <div class="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
        <div class="absolute bottom-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
      </div>

      <!-- 内容区域 -->
      <div class="relative z-10 flex flex-col justify-center px-12 py-16 text-white">
        <!-- 品牌标语 -->
        <div class="mb-12">
          <h2 class="text-4xl font-bold mb-4">您身边的财务总监</h2>
          <p class="text-xl text-white/80">专业财务管理，助力企业基业长青</p>
        </div>

        <!-- 核心理念 -->
        <div class="space-y-8">
          <div class="flex items-start gap-4">
            <div class="flex-shrink-0 w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
              </svg>
            </div>
            <div>
              <h3 class="font-semibold text-lg">业财一体化</h3>
              <p class="text-white/70 text-sm mt-1">业务与财务深度融合，数据驱动决策</p>
            </div>
          </div>

          <div class="flex items-start gap-4">
            <div class="flex-shrink-0 w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div>
              <h3 class="font-semibold text-lg">资金安全管理</h3>
              <p class="text-white/70 text-sm mt-1">全程监控资金流向，保障企业资金安全</p>
            </div>
          </div>

          <div class="flex items-start gap-4">
            <div class="flex-shrink-0 w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
            </div>
            <div>
              <h3 class="font-semibold text-lg">智能财务报表</h3>
              <p class="text-white/70 text-sm mt-1">一键生成多维度报表，精准掌控经营状况</p>
            </div>
          </div>

          <div class="flex items-start gap-4">
            <div class="flex-shrink-0 w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
              </svg>
            </div>
            <div>
              <h3 class="font-semibold text-lg">合规风险控制</h3>
              <p class="text-white/70 text-sm mt-1">自动合规检查，规避财税风险</p>
            </div>
          </div>
        </div>

        <!-- 企业客户展示 -->
        <div class="mt-16">
          <p class="text-sm text-white/60 mb-4">已服务超过 1000+ 企业客户</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/user'
import { sendResetSmsCode, resetPasswordBySms } from '@/api/auth'

const router = useRouter()
const userStore = useUserStore()

// ========== 视图切换 ==========
const currentView = ref('login') // 'login' | 'tenant' | 'reset'

const viewSubtitle = computed(() => {
  if (currentView.value === 'login') return '登录管理后台'
  if (currentView.value === 'tenant') return '选择租户'
  return '重置登录密码'
})

function switchToReset() {
  currentView.value = 'reset'
  resetError.value = ''
}

function switchToLogin() {
  currentView.value = 'login'
  tenantList.value = []
  tenantAccountId.value = null
  resetForm.phone = ''
  resetForm.smsCode = ''
  resetForm.newPassword = ''
  resetForm.confirmPassword = ''
  resetError.value = ''
  countdown.value = 0
  if (countdownTimer) {
    clearInterval(countdownTimer)
    countdownTimer = null
  }
}

// ========== 登录表单 ==========
const loading = ref(false)
const showPassword = ref(false)
const form = reactive({
  phone: '',
  password: '',
  remember: false
})

// ========== 记住我 ==========
const REMEMBER_KEY = 'rememberedPhone'

onMounted(() => {
  const saved = localStorage.getItem(REMEMBER_KEY)
  if (saved) {
    form.phone = saved
    form.remember = true
  }
})

function saveOrClearRemember() {
  if (form.remember) {
    localStorage.setItem(REMEMBER_KEY, form.phone)
  } else {
    localStorage.removeItem(REMEMBER_KEY)
  }
}

// ========== 租户选择 ==========
const tenantList = ref([])
const tenantAccountId = ref(null)
const selectingTenant = ref(false)

const handleLogin = async () => {
  if (!form.phone) {
    ElMessage.warning('请输入手机号')
    return
  }
  if (!form.password) {
    ElMessage.warning('请输入密码')
    return
  }

  loading.value = true
  try {
    const res = await userStore.doLogin(form.phone, form.password)
    if (res.requireTenantSelection) {
      tenantAccountId.value = res.accountId
      tenantList.value = res.tenants || []
      currentView.value = 'tenant'
      saveOrClearRemember()
    } else if (res.forceChangePassword) {
      saveOrClearRemember()
      router.push('/force-change-password')
    } else {
      saveOrClearRemember()
      ElMessage.success('登录成功')
      router.push('/dashboard')
    }
  } catch (error) {
    ElMessage.error(error.message || '登录失败')
  } finally {
    loading.value = false
  }
}

const handleSelectTenant = async (tenant) => {
  selectingTenant.value = true
  try {
    const res = await userStore.doSelectTenant(tenantAccountId.value, tenant.tenantId)
    if (res.forceChangePassword) {
      router.push('/force-change-password')
    } else {
      ElMessage.success('登录成功')
      router.push('/dashboard')
    }
  } catch (error) {
    ElMessage.error(error.message || '登录失败')
  } finally {
    selectingTenant.value = false
  }
}

// ========== 重置密码表单 ==========
const resetForm = reactive({
  phone: '',
  smsCode: '',
  newPassword: '',
  confirmPassword: ''
})
const resetError = ref('')
const resetting = ref(false)
const showResetPassword = ref(false)
const showResetConfirmPassword = ref(false)

// 验证码倒计时
const countdown = ref(0)
const sendingCode = ref(false)
let countdownTimer = null

const resetConfirmError = computed(() => {
  return resetForm.confirmPassword !== '' &&
    resetForm.newPassword !== '' &&
    resetForm.confirmPassword !== resetForm.newPassword
})

function startCountdown() {
  countdown.value = 60
  countdownTimer = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(countdownTimer)
      countdownTimer = null
    }
  }, 1000)
}

async function handleSendCode() {
  if (!resetForm.phone) {
    ElMessage.warning('请输入手机号')
    return
  }
  if (!/^1\d{10}$/.test(resetForm.phone)) {
    ElMessage.warning('请输入正确的手机号')
    return
  }

  sendingCode.value = true
  try {
    await sendResetSmsCode(resetForm.phone)
    ElMessage.success('验证码已发送')
    startCountdown()
  } catch (error) {
    ElMessage.error(error.message || '验证码发送失败')
  } finally {
    sendingCode.value = false
  }
}

async function handleResetPassword() {
  resetError.value = ''

  if (!resetForm.phone) {
    resetError.value = '请输入手机号'
    return
  }
  if (!/^1\d{10}$/.test(resetForm.phone)) {
    resetError.value = '请输入正确的手机号'
    return
  }
  if (!resetForm.smsCode) {
    resetError.value = '请输入验证码'
    return
  }
  if (!resetForm.newPassword) {
    resetError.value = '请输入新密码'
    return
  }
  const password = resetForm.newPassword
  if (password.length < 6 || password.length > 20) {
    resetError.value = '密码长度必须在6-20位之间'
    return
  }
  if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(password)) {
    resetError.value = '密码必须包含大小写字母和数字'
    return
  }
  if (password !== resetForm.confirmPassword) {
    resetError.value = '两次输入的密码不一致'
    return
  }

  resetting.value = true
  try {
    await resetPasswordBySms({
      phone: resetForm.phone,
      code: resetForm.smsCode,
      newPassword: resetForm.newPassword
    })
    ElMessage.success('密码重置成功，请使用新密码登录')
    switchToLogin()
  } catch (error) {
    resetError.value = error.message || '重置密码失败'
  } finally {
    resetting.value = false
  }
}

onUnmounted(() => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
  }
})
</script>
